import {useMutation} from 'react-query'

import {mutations} from '../../mutations'

export const usePostSlotReservation = () => {
  return useMutation(mutations.postSlotReservation)
}
